import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import IconButton from 'components/atoms/Button/IconButton';
import { disableAllMenu } from 'modules/actions/statusMenu';
import { sendSatisfy } from 'modules/actions/starScore';
import './style.scss';
const ServiceGuide = () => {
  const dispatch = useDispatch();
  const closeServiceGuide = () => {
    dispatch(disableAllMenu());
    // setPayloadStatus({ score: 5, name: '매우만족', content: '', status: 'N' });
  };
  const [displayStatus, setDisplayStatus] = useState({ guide: true, auto: false });

  // // state
  // const [payloadStatus, setPayloadStatus] = useState({ score: 5, name: '매우만족', content: '' });
  // const StarName = ['매우불편', '불편', '보통', '만족', '매우만족'];

  // // event
  const changeDisplay1 = () => {
    setDisplayStatus({ guide: true, auto: false });
  };
  const changeDisplay2 = () => {
    setDisplayStatus({ guide: false, auto: true });
  };

  /* 사이드메뉴 클릭시 다른 메뉴창 닫힘 */
  const onSideMenu = () => {
    if (settingMenuStatus === true) {
      dispatch(disableAllMenu());
    }
    if (quickMenuStatus) {
      dispatch(isActiveQuickMenu());
    }
    if (expandImageModalStatus) {
      dispatch(isActiveExpandImageModal());
    }
    dispatch(isActiveSideMenu());
  };

  // const setContentValue = contentStr => {
  //   if (contentStr) {
  //     setPayloadStatus({ ...payloadStatus, content: contentStr, status: 'Y' });
  //   } else {
  //     setPayloadStatus({ ...payloadStatus, content: contentStr, status: 'N' });
  //   }
  // };
  return (
    <div className="help_area">
      <div className="help_header">
        <span>이용 안내</span>
        <i className="ri-close-line" onClick={closeServiceGuide} />
      </div>
      <div className="help_tab_area">
        <div
          className="help_tab"
          onClick={changeDisplay1}
          style={{
            borderBottom: displayStatus.guide ? '4px #3572D3 solid' : '',
            color: displayStatus.guide ? '#3572D3' : '',
            fontWeight: displayStatus.guide ? '600' : '400',
          }}
        >
          챗봇 메뉴
        </div>
        <div
          className="help_tab"
          onClick={changeDisplay2}
          style={{
            borderBottom: displayStatus.auto ? '4px #3572D3 solid' : '',
            color: displayStatus.auto ? '#3572D3' : '',
            fontWeight: displayStatus.auto ? '600' : '400',
          }}
        >
          질문 자동 완성
        </div>
      </div>
      <div className="help_content">
        <img src="/chat/images/help01.png" alt="" className="img_help" style={{ display: displayStatus.guide ? 'inline-block' : 'none' }} />
        <img src="/chat/images/help02.png" alt="" className="img_help" style={{ display: displayStatus.auto ? 'inline-block' : 'none' }} />
      </div>
    </div>
  );
};

export default ServiceGuide;
